import { Route, RouteConfig } from 'vue-router/types/router';
import GoalSettingPage from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/goal-setting.page.vue';
import GoalHomePage from '@/modules/business-plan/modules/approval/pages/home/goal-home.page.vue';
import ToyotaGoalSettingPage from '@/modules/business-plan/modules/approval/pages/toyota-goal-settings/goal-setting.page.vue';
import ToyotaGoalVsRegistrationReport from '@/modules/business-plan/modules/report/toyota-goal-vs-registration-report.page.vue';
import VolvoGoalSettingPage from '@/modules/business-plan/modules/approval/pages/volvo-goal-settings/goal-setting.page.vue';

const basePath = '/business_plan/approval';

export const BPA_ROUTES = {
  HOME: 'bpa-home-page',
  GOAL_SETTINGS: 'goal_settings',
  GOAL_SETTINGS_TOYOTA: 'goal_settings_toyota',
  GOAL_SETTINGS_VOLVO: 'goal_settings_volvo',
  GOAL_VS_REGISTRATION_TOYOTA: 'goal_vs_registration_toyota',
  TOYOTA_DEALER_EVALUATION: 'toyota_dealer_evaluation'
};

const bpaRoutes: RouteConfig[] = [
  {
    path: `${basePath}`,
    name: BPA_ROUTES.HOME,
    component: GoalHomePage
  },
  {
    path: `${basePath}/project/:idProject/:idGroup/:idLocale/${BPA_ROUTES.GOAL_SETTINGS}`,
    name: BPA_ROUTES.GOAL_SETTINGS,
    component: GoalSettingPage,
    props: (route: Route) => ({
      idProject: route.params.idProject,
      idGroup: route.params.idGroup,
      idLocale: route.params.idLocale
    })
  },
  {
    path: `${basePath}/project/:idProject/:idGroup/:idLocale/${BPA_ROUTES.GOAL_SETTINGS_VOLVO}`,
    name: BPA_ROUTES.GOAL_SETTINGS_VOLVO,
    component: VolvoGoalSettingPage,
    props: (route: Route) => ({
      idProject: route.params.idProject,
      idGroup: route.params.idGroup,
      idLocale: route.params.idLocale
    })
  },
  {
    path: `${basePath}/project/:idProject/:idGroup/:idLocale/${BPA_ROUTES.GOAL_SETTINGS_TOYOTA}`,
    name: BPA_ROUTES.GOAL_SETTINGS_TOYOTA,
    component: ToyotaGoalSettingPage,
    props: (route: Route) => ({
      idProject: route.params.idProject,
      idGroup: route.params.idGroup,
      idLocale: route.params.idLocale
    })
  },
  {
    path: `${basePath}/${BPA_ROUTES.GOAL_VS_REGISTRATION_TOYOTA}`,
    name: BPA_ROUTES.GOAL_VS_REGISTRATION_TOYOTA,
    component: ToyotaGoalVsRegistrationReport,
  }
];

export default bpaRoutes;
